import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "../hooks/react-auth0-spa";

import { API_URL } from "../constants/constants";

export const useRecoleccionesAPI = (initialUser = "") => {
  const [user, setUser] = useState(initialUser);
  const [data, setData] = useState({});
  const [isLoadingRecoleccion, setIsLoading] = useState(false);
  const [isErrorRecoleccion, setIsErrorRecoleccion] = useState(false);
  const { getTokenSilently, user: user2 } = useAuth0();

  useEffect(() => {
    const fetchStatistics = async () => {
      setIsLoading(true);
      try {
        const t = await getTokenSilently();
        const r = await axios.get(API_URL + `/recolecciones/${user2.sub}`, {
          headers: {
            // "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${t}`
          }
        });
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        setIsErrorRecoleccion(true)
;        console.log(error);
      }
      setIsLoading(false);
    };
    fetchStatistics();
    // eslint-disable-next-line
  }, [user]);

  return [{ data, isLoadingRecoleccion,isErrorRecoleccion }, setUser];
};

export default useRecoleccionesAPI;
